export default "__VITE_ASSET__284ed85c__"